import { MultiFactorInfo, MultiFactorResolver } from 'firebase/auth';

export const MULTIFACTOR_ENROLLMENT_ROUTE = '/multifactor/enrol';
export const MULTIFACTOR_VERIFY_ROUTE = '/multifactor/verify';

export enum MultifactorMethod {
  Phone = 'phone',
  Totp = 'totp',
}

export enum MultifactorFactorId {
  Phone = 'phone',
  Totp = 'totp',
}

export enum MultifactorEnrolmentState {
  NotEnrolled = 'not_enrolled',
  EnrolledPhone = 'enrolled_phone',
  EnrolledTotp = 'enrolled_totp',
  EnrolledBoth = 'enrolled_both',
}

export interface IMultifactorVerificationContext {
  resolver: MultiFactorResolver;
  hints: MultiFactorInfo[];
  selectedHint?: MultiFactorInfo;
}

/**
 * E.164 international phone number format: + followed by 1-15 digits,
 * first digit must be 1-9 (no leading zero after +).
 * Examples: +61412345678, +15551234567
 */
export const E164_PHONE_PATTERN = /^\+[1-9]\d{1,14}$/;

export interface IMultifactorEnrolmentResult {
  success: boolean;
  method: MultifactorMethod;
  error?: string;
}
